var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('box',{ref:_vm.boxRef,attrs:{"customer":true,"autoLoad":false,"title":"万里牛订单","width":1000,"index":0,"moduleName":"online","store":_vm.store,"selectType":"checkbox"},on:{"hide":_vm.hide,"submit":_vm.submit,"boxdataload":_vm.boxdataload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }